var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  "+_vm._s(_vm.currentValue.toLocaleString('en-US', {maximumFractionDigits:2}))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }